<div *ngIf="senha!='wellness'" style="text-align: center;">
  <div style="display: inline-block;">
    Senha <input  [(ngModel)]="senha" (ngModelChange)="mudouSenha()" type="text" [style]="{'width':'130px','height':'20px'}"  pInputText>
  </div>
  
</div>

<div *ngIf="senha=='wellness'">



<div style="text-align: center;width: fit-content;font-family: 'Roboto';">
  <div class="titulo" style="margin-top: 30%;">Ouvidoria do Diviprev</div>
  <div class="titulo" style="font-size: 4em;">Relatório Semestral</div>
  <div class="subtitulo" *ngIf="semestre=='primeiro'">Janeiro - Junho de {{ano}} </div>
  <div  class="subtitulo" *ngIf="semestre!='primeiro'">Julho - Dezembro de {{ano}} </div>
  <div class="pessoais" id="quebra">
    Reponsável: Paulo Eduardo Santos
    <div>Matrícula: 02023936</div>
  </div>


  <div class="espacar">
    <div class="mark">Acerca da Ouvidoria:</div>
    <div class="texto">
      Compete a Ouvidoria receber denúncias, reclamações e representações sobre atos considerados ilegais, arbitrários, desonestos, ou que, 
      de maneira geral, contrariem os interesses públicos, praticados por servidores públicos do Instituto de Previdência dos Servidores do Municipio.
    </div>
    <div class="texto">
      Os contatos dos cidadãos com a Ouvidoria poderão ser feitos pessoalmente ou pela internet, através do site do Diviprev.
    </div>
  </div>

  <div class="mark espacar">
    Atendimentos realizados por meio do site do Instituto:
  </div>

  <table class="espacarCurto">
    <tr>
      <th>Tipo</th>
      <th *ngFor="let col of colunas">{{col | mes}}</th>
      
      
    </tr>
    
    
    <tr *ngFor="let linha of linhas">
      <td>{{linha}}</td>
      <td *ngFor="let col of colunas"><div class="dt">{{quantitativos[col][linha]}}</div></td>
    </tr>
    
  </table>

  <div class="mark espacar">
    Grafico comparativo do total de atendimentos realizados por competência
  </div>
  <div>
    <canvas id="myChart"></canvas>
  </div>

  <div class="texto espacarCurto" id="quebra">
    Como de costume a maioria das solicitações e interações que se deram com a Ouvidoria deste Instituto ocorreu por meio de canais digitais e, 
    pelos mesmos canais os munícipes foram respondidos. Fica registrado também que na confecção deste relatório, todas as solicitações e informações 
    foram devidamente respondidas.
  </div>

  <!-- <div class="mark espacar">
    Atendimentos presenciais e por meio de telefone:
  </div>
  <div class="texto espacarCurto">
    Durante o período de compilação deste relatório <b>houve apenas um</b> atendimento por meio telefônico, sendo este resolvido e o resultado submetido também por telefone, 
    conforme optou o solicitante. <br>
  </div> -->

  <div class="mark espacar">
    Pesquisa de satisfação registrada durante o período:
  </div>

  <div class="texto espacarCurto">
    No site do Instituto, existe uma enquete em que os segurados podem avaliar as dependências do Instituto (instalação física), o site e a qualidade 
    do atendimento em geral (pesencial e por telefone). Sendo que nesta o segurado pode avaliar cada um dos respectivos itens com uma nota de 
    <b>zero(péssimo) a cinco(ótimo).</b>
  </div>
  <div class="texto">
    A enquete pode ser acessada no site do Instituto (http://diviprev.mg.gov.br/?page_id=8910), abaixo segue o compilado da média das notas colhidas
     nos útlimos seis meses.
  </div>

  <div class="mark espacar">
    Média de avaliações da pesquisa de satisfação durante o período de compilação do relatório:
  </div>

  <div style="text-align: center;">
    <table class="espacarCurto" style="display: inline-block;">
      <tr>
        <th></th>
        <th *ngFor="let col of mesesAlvo">{{col | mes}}</th>
        
        
      </tr>
      
      
      <tr>
        <td>Site</td>
        <td *ngFor="let reg of mesesAlvo;index as ind">{{pesquisaProduto['site'][ind]}}</td>
      </tr>
      <tr>
        <td>Atendimento</td>
        <td *ngFor="let reg of mesesAlvo;index as ind">{{pesquisaProduto['atendimento'][ind]}}</td>
      </tr>
      <tr>
        <td>Dependencias</td>
        <td *ngFor="let reg of mesesAlvo;index as ind">{{pesquisaProduto['dependencias'][ind]}}</td>
      </tr>
      
    </table>
  </div>
  
  <div class="texto" style="text-align: center;">
    Os meses marcados com traços (-) não possuem avaliações, portanto não entram na média.
  </div>
  <div class="texto" style="text-align: center;">
    A média total geral de avaliações, em todas as categorias foi de <b>{{mediaGeral}}</b>.
  </div>
  <div class="texto">
    Durante o período do relatório, foram resgistradas <span class="destaque-numero">{{totalAvaliacoesPesquisa}}</span> pesquisa de satisfação de nossos segurados, dado este utilizado 
    para construção da tabela mediana acima. As pesquisas de satisfação são solicitadas dos segurados ao visitarem o site do Instituto, sendo 
    estas de caráter facultativo.
  </div>


  <div class="texto ">
    Portanto, fica exposto neste relatório que esta Ouvidoria vem realizando atendimentos recorrentes e que todos 
    foram prontamente atendidos, ou seja, houve resposta em tempo oportuno para os munícipes que solicitaram serviços, esclarecimentos e 
    que por ventura tenha manifestado alguma reclamação. É notório também a preferência pelos meios digitais no que abrange os atendimentos de forma geral durante o período de compilação 
    deste relatório.
  </div>
  

  <div class="texto">
    Na oportunidade, que fique registrado a presteza e diligência de todos os setores do Instituto diretamente envolvidos em dirimir as 
    solicitações e indagações dos segurados e demais manifestantes, garantindo em sua totalidade celeridade nas respostas.
  
  </div>

  <div class="texto espacar">
    Tendo exposto as informações do semestre, esta Ouvidoria declara encerrado o relatório, estando a disposição para quaisquer esclarecimentos.
  
  </div>

  <div class="texto espacar" style="text-align: right;">
    Divinópolis, {{hoje.getDate()}} de {{(hoje.getUTCMonth() + 1)| mes}} de {{hoje.getUTCFullYear()}}
  
  </div>

  <div style="text-align: center;margin-top: 80px;">
    <div style="display: inline-block;position: relative;"> 
      <div style="border-bottom: solid 1px black; width: 300px;"></div>
      <div style=" width: 300px;">Paulo Eduardo Santos</div>
      <div style=" width: 300px;">Matricula: 02023936</div>
      <div style=" width: 300px;">Ouvidoria</div>
    </div>
    
  </div>


</div>

</div>